// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__GP2fb","footer":"ModalCreateQualiphyProcedure_footer__2BcnD","additionData":"ModalCreateQualiphyProcedure_additionData__hrCQ4"};